/**
 * Source unique de vérité pour toutes les URLs de l'API.
 * TOUS les fichiers doivent importer depuis ce fichier.
 * Aucun autre fichier ne doit utiliser import.meta.env.VITE_API_* directement.
 *
 * Variables d'environnement attendues dans .env :
 *   VITE_API_BASE_URL=https://api.meyebus.ma   (sans /api)
 *   VITE_WEBSOCKET_URL=wss://api.meyebus.ma
 */

// ─── URL de base (sans /api) ──────────────────────────────────────────────────
// Utilisée par les hooks qui construisent leurs propres chemins (/api/auth/...)
const _raw = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

// Normaliser : supprimer le /api final s'il est accidentellement présent
export const API_HOST = _raw.replace(/\/api\/?$/, '');

// ─── URL avec /api ─────────────────────────────────────────────────────────────
// Utilisée par les services qui appellent directement /admin/..., /auth/..., etc.
export const API_BASE_URL = `${API_HOST}/api`;

// ─── URL WebSocket ─────────────────────────────────────────────────────────────
export const WS_URL =
  import.meta.env.VITE_WEBSOCKET_URL || API_HOST.replace('https://', 'wss://').replace('http://', 'ws://');

export default { API_HOST, API_BASE_URL, WS_URL };
